import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "w-[350px] p-5 flex flex-col h-full items-start overflow-hidden border-r border-gray-200"
};
const _hoisted_2 = {
  class: "w-full h-7 text-5 text-center leading-[28px] title"
};
const _hoisted_3 = {
  class: "flex items-center gap-2"
};
const _hoisted_4 = {
  class: "w-full overflow-y-auto"
};
const _hoisted_5 = {
  class: "mt-[10px]"
};
const _hoisted_6 = {
  class: "w-full"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'Left',
  props: {
    knowledge: {}
  },
  emits: ['back'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_text = _resolveComponent("el-text");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = $event => emits('back')),
        size: "small"
      }, {
        icon: _withCtx(() => [_createVNode(_component_Icon, {
          icon: "mynaui:fat-arrow-left"
        })]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.knowledge?.name), 1)]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_el_text, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.knowledge?.description), 1)]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "default")])]);
    };
  }
});